<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ "USUARIOCOMISIONFREELANCE.LBL_COMISIONESFREELANCE" | translate }}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <form (ngSubmit)="buscar()" [formGroup]="formulario">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <button type="button" pButton icon="fa fa-plus" (click)="crearComisionFreelance()" *ngIf="menu.agregar"
            label="{{ 'USUARIOCOMISIONFREELANCE.BTN_AGREGARCOMISIONFREELANCE' | translate }}"></button>
        </div>
        <div class="col-12 md:col-6 lg:col-6 flex align-items-center justify-content-end pr-0">
          <div class="div-form col-9 md:col-9 lg:col-9 font-size-adm-preapro">
            <input style="background: white" id="idFiltro" type="text" pInputText size="40" (keyup.enter)="buscar()"
              autocomplete="new-password" appTexto placeholder="{{
              'LBL_BUSCAR' | translate
            }}" formControlName="filtro" [maxlength]="100" />
          </div>

          <div class="div-form">
            <div class="form-group">
              <button type="submit" icon="fa fa-search" class="p-button p-button-success btn" data-toggle="tooltip"
              title="{{'BTN_BUSCAR' | translate}}" style="margin-top: 7px"
              pButton></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carComisionFreelance" #dt [value]="usuariosComisionesFreelance"
      selectionMode="single" dataKey="idComisionFreelance" [paginator]="true" [rows]="10" [totalRecords]="numRegistros"
      [rows]="regPorPagina"  paginatorPosition="bottom" [lazy]="true" (onLazyLoad)="buscar($event)">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
            class="text-center">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td class="text-center">{{ row.numeroDocumento }}</td>
          <td class="text-center">{{ row.usuarioFreelance }}</td>
          <td class="text-center">{{ row.usuarioSistema }}</td>
          <td class="text-center">{{ row.porcentajeComision }}</td>
          <td class="text-center">{{ row.baseFreelance }}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                title="{{ 'BTN_VISUALIZAR' | translate }}" pButton (click)="verComisionFreelance(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                title="{{ 'BTN_EDITAR' | translate }}" pButton *ngIf="menu.editar"
                (click)="editarComisionFreelance(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-clock-o" data-toggle="tooltip"
                title="{{ 'USUARIOCOMISIONFREELANCE.BTN_HISTORIAL' | translate }}" pButton (click)="historialComisionFreelance(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ "MSG_NOHAYREGISTROS" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="{{ 'USUARIOCOMISIONFREELANCEHISTORICO.LBL_LOGDECAMBIOS' | translate}}" [(visible)]="mosModalHistorico"
  [contentStyle]="{'width':'1000px'}" modal="true" *ngIf="mosModalHistorico">
  <div class="grid">
    <div class="col-12 lg:col-12 md:col-12">
      <p-table [columns]="colHistoricos" [value]="usuariosComisionesFreelanceHistoricos" selectionMode="single"
        dataKey="idUsuariosComisionesFreelanceHistoricos" [paginator]="true" [rows]="5"
        paginatorPosition="bottom" [loading]="carInformacionHistorico">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
              class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.auditoriaFecha | date :'dd/MM/yyyy HH:mm'}}</td>
            <td>{{row.usuarioSistemaModifica}}</td>
            <td>{{row.ipPublica}}</td>
            <td>{{row.ipLocal}}</td>
            <td>{{row.datoAnterior}}</td>
            <td>{{row.datoNuevo}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button" pButton
        (click)="cerrarModalHistorico()"></button>
    </div>
  </div>
</p-dialog>
